// framework/client/core/RpcClient.js

export class RpcClient {
  constructor(socket, appClient, config) {
    this.socket = socket;
    this.rpcIdCounter = 0;
    this.callbacks = {};
    this.appClient = appClient;
    this.config = {
      errorHandler: {
        default: (error) => {
          console.error("RPC Error:", error);
          // You can use the Notifier here if it's accessible
          if (this.appClient && this.appClient.notifier) {
            this.appClient.notifier.error("An error occurred: " + error.message);
          } else {
            alert("An error occurred: " + error.message);
          }
        },
        middleware: {
          // You can define specific handlers for middleware errors
          // Example:
          Login: (error) => {
            // Redirect to login page
          },
        },
      },
      ...config,
    };
    this.setupListeners();
  }

  setupListeners() {
    this.socket.on("rpcResponse", (response) => {
      this.handleRpcResponse(response);
    });
  }

  handleRpcResponse(response) {
    if (this.callbacks[response.id]) {
      if (response.error) {
        // Handle errors based on configuration
        if (response.error.type === "middleware" || response.error.type === "validation") {
          const handler =
            this.config.errorHandler.middleware[response.error.name] ||
            this.config.errorHandler.default;
          handler(response.error);
        } else {
          this.config.errorHandler.default(response.error);
        }


        // Call the stored reject function
        this.callbacks[response.id].reject(response.error);
      } else {
        // Call the stored resolve function
        this.callbacks[response.id].resolve(response.result);
      }
      delete this.callbacks[response.id];
    }
  }

async call(rpcMethod, params = {}, context = {}) {
        return new Promise((resolve, reject) => {
            const rpcId = ++this.rpcIdCounter;
            const sessionToken = this.appClient.sessionTokenHandler
                ? this.appClient.sessionTokenHandler.getToken()
                : null;

            // 1. Get the autoContextKeys from the client configuration.
            const clientConfig = this.appClient.sessionTokenHandler
                ? this.appClient.sessionTokenHandler.getClientConfig()
                : this.appClient.config;
            const autoContextKeys = clientConfig?.rpc?.autoContextKeys || [];

            // 2. Create the final context object, starting with the explicitly passed context.
            const finalContext = { ...context };

            // 3. Iterate over the configured keys and inject data from the shared store.
            //    This will NOT overwrite any values that were explicitly passed in the `context` object.
            for (const key of autoContextKeys) {
                if (finalContext[key] === undefined) { // Check if the key is not already set
                    const sharedValue = this.appClient.getSharedData(key);
                    if (sharedValue !== undefined && sharedValue !== null) {
                        finalContext[key] = sharedValue;
                    }
                }
            }

            this.socket.emit("rpc", {
                id: rpcId,
                sessionToken: sessionToken,
                method: rpcMethod,
                params: params,
                context: finalContext, // 4. Send the final, enriched context.
            });

            this.callbacks[rpcId] = { resolve, reject };
        });
    }
}
